import { useEffect, useState } from "react";
import get from "lodash/get";
import { Card, Descriptions, Spin, Tag } from "antd";
import { useParams } from "react-router-dom";
import { ORDER_STATUS_COLORS, readableDateTime } from "../../utilities/helper";
import { getApi } from "../../redux/rest/restSlice";
import { unwrapResult } from "@reduxjs/toolkit";
import { ORDER_DETAILS } from "../../constants/actionTypes";
import { useDispatch } from "react-redux";
import PageHeader, { useGoBack } from "../../components/PageHeader";
import CopyText from "../../components/CopyText";

const OrderDetailScreen = () => {
  const [loading, setLoading] = useState(true); // Set loading to true initially
  const { orderId } = useParams();
  const dispatch = useDispatch();
  const goBack = useGoBack();
  const [orderDetails, setOrderDetails] = useState(null); // Initialize orderDetails as null



  const getOrderDetails = () => {
    dispatch(
      getApi({
        endpoint: `${ORDER_DETAILS}/${orderId}`,
      })
    )
      .then(unwrapResult)
      .then((result) => {
        setLoading(false);
        setOrderDetails(get(result, "data"));
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!orderId) return;
    getOrderDetails();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  if (loading) {
    return (
      <div className="page-loading">
        <Spin size="large" spinning={loading} />
      </div>
    );
  }

  if (!orderDetails) {
    return null;
  }

  return (
    <div className="page">
      <PageHeader onBack={goBack} title={`Order ${get(orderDetails, "order_id", "")}`} />

      <Card bordered={false} className="section-card">
        <Descriptions column={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }} size="default" bordered>
          <Descriptions.Item label="Order ID">
            <CopyText value={get(orderDetails, "order_id")} />
          </Descriptions.Item>
          <Descriptions.Item label="Order Status">
            {get(orderDetails, "order_status") ? (
              <Tag color={ORDER_STATUS_COLORS[get(orderDetails, "order_status")] || "default"}>
                {get(orderDetails, "order_status")}
              </Tag>
            ) : (
              get(orderDetails, "order_status")
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Payment Intent ID">
            {get(orderDetails, "payment_intent_id")
              ? <CopyText value={get(orderDetails, "payment_intent_id")} />
              : "--"}
          </Descriptions.Item>
          <Descriptions.Item label="Battery Identifier">
            {get(orderDetails, "battery_identifier")
              ? <CopyText value={get(orderDetails, "battery_identifier")} />
              : "--"}
          </Descriptions.Item>
          <Descriptions.Item label="Pickup Cabinet Identifier">
            {get(orderDetails, "cabinet_identifier")
              ? <CopyText value={get(orderDetails, "cabinet_identifier")} />
              : "--"}
          </Descriptions.Item>
          <Descriptions.Item label="Pickup Cabinet Name">
            {get(orderDetails?.PickupCabinet, "name")
              ? `${get(orderDetails?.PickupCabinet, "name")}`
              : "--"}
          </Descriptions.Item>
          <Descriptions.Item label="Return Cabinet Identifier">
            {get(orderDetails, "return_cabinet_identifier")
              ? <CopyText value={get(orderDetails, "return_cabinet_identifier")} />
              : "--"}
          </Descriptions.Item>
          <Descriptions.Item label="Return Cabinet Name">
            {get(orderDetails?.ReturnCabinet, "name")
              ? `${get(orderDetails?.ReturnCabinet, "name")}`
              : "--"}
          </Descriptions.Item>
          <Descriptions.Item label="Sales Tax Percent">
            {get(orderDetails, "sales_tax_percent")
              ? `${get(orderDetails, "sales_tax_percent")}%`
              : "--"}
          </Descriptions.Item>
          <Descriptions.Item label="Tax Deducted">
            {get(orderDetails, "tax_deducted")
              ? `$${get(orderDetails, "tax_deducted")}`
              : "--"}
          </Descriptions.Item>
          <Descriptions.Item label="Order Amount">
            {get(orderDetails, "order_amount")
              ? `$${get(orderDetails, "order_amount")}`
              : "--"}
          </Descriptions.Item>
          <Descriptions.Item label="Amount Deducted">
            {get(orderDetails, "amount_deducted")
              ? `$${get(orderDetails, "amount_deducted")}`
              : "--"}
          </Descriptions.Item>
          <Descriptions.Item label="Created At">
            {get(orderDetails, "created_at")
              ? readableDateTime(
                  get(orderDetails, "created_at"),
                  "dd/mm/yyyy hh:mm"
                )
              : "--"}
          </Descriptions.Item>
          <Descriptions.Item label="Updated At">
            {get(orderDetails, "updated_at")
              ? readableDateTime(
                  get(orderDetails, "updated_at"),
                  "dd/mm/yyyy hh:mm"
                )
              : "--"}
          </Descriptions.Item>
          <Descriptions.Item label="Battery Pickup Time">
            {get(orderDetails, "battery_pickup_time")
              ? readableDateTime(
                  get(orderDetails, "battery_pickup_time"),
                  "dd/mm/yyyy hh:mm"
                )
              : "--"}
          </Descriptions.Item>
          <Descriptions.Item label="Battery Return Time">
            {get(orderDetails, "battery_return_time")
              ? readableDateTime(
                  get(orderDetails, "battery_return_time"),
                  "dd/mm/yyyy hh:mm"
                )
              : "--"}
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </div>
  );
};

export default OrderDetailScreen;
